// import { createReducer } from "./functions";
import {
  SET_CURRENT_CLIENT,
} from "./../types";


export default (state = {}, action) => {
  switch(action.type) {
    case SET_CURRENT_CLIENT:
      return {
        ...state,
        ...action.clientInfos
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// src/redux/reducers/currentClientReducer.js